import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, Table, Input, FormGroup, Label, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import UiContent from "../../../../Components/Common/UiContent";
import BetterStandsContext from "../../../../Components/Contexts/Management/BetterStandsContext";
import DenetimFormu from '../../Forms/DenetimFormu';
import { useTranslation } from "react-i18next";
import i18n from "../../../../i18n";

const tableStyles = {
    tableResponsive: {
        overflowX: 'auto',
        width: '100%'
    },
    table: {
        width: '100%'
    },
    cell: {
        wordBreak: 'break-word',
        maxWidth: '200px'
    }
};

const ConstantElektrikDenetim = () => {
  const { t } = useTranslation("saha");
    const documentTitle = t("constantElektrikDenetim.n24SaatElektrik");
    useEffect(() => { document.title = documentTitle + i18n.t("saha:constantElektrikDenetim.standlar"); }, [documentTitle]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedStand, setSelectedStand] = useState(null);
    const {
        fetchActiveFairId,
        fetchActiveStands,
        activeFairId,
        stands
    } = useContext(BetterStandsContext);

    useEffect(() => {
        const initializePage = async () => {
            setLoading(true);
            try {
                const userId = localStorage.getItem('userId');
                if (!userId) {
                    console.error("User ID not found in localStorage");
                    return;
                }
                await fetchActiveFairId(userId);
            } catch (error) {
                console.error("Error initializing page:", error);
            } finally {
                setLoading(false);
            }
        };

        initializePage();
    }, [fetchActiveFairId]);

    useEffect(() => {
        if (activeFairId) {
            fetchActiveStands(0, 50, null, searchTerm, activeFairId);
        }
    }, [activeFairId, fetchActiveStands, searchTerm]);

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredStands = stands.filter(stand =>
        stand.stand_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        stand.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        stand.hall?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        stand.type?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const openDenetimFormu = (stand) => {
        setSelectedStand(stand);
        setModalOpen(true);
    };

    const closeDenetimFormu = () => {
        setSelectedStand(null);
        setModalOpen(false);
    };

    return (
        <React.Fragment>
            <UiContent />
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("constantElektrikDenetim.n24SaaatElektrikDenetim")} pageTitle={t("constantElektrikDenetim.n24SaaatElektrik")} />
                    <Row>
                        <Col xs={12}>
                            <Card>
                                <CardBody>
                                    <FormGroup className="mb-3">
                                        <Label for="searchInput">{t("common:ara")}</Label>
                                        <Input
                                            id="searchInput"
                                            type="text"
                                            value={searchTerm}
                                            onChange={handleSearch}
                                            placeholder={t("constantElektrikDenetim.standAdiFirmaAdiVeya")}
                                        />
                                    </FormGroup>
                                    {loading ? (
                                        <p>{t("common:yukleniyor")}</p>
                                    ) : stands.length === 0 ? (
                                        <p>{t("constantElektrikDenetim.hicFormBulunamadi")}</p>
                                    ) : (
                                        <Table className="table align-middle" style={tableStyles.table}>
                                            <thead>
                                            <tr>
                                                <th>{t("constantElektrikDenetim.standAdi")}</th>
                                                <th>{t("constantElektrikDenetim.firmaAdi")}</th>
                                                <th>{t("constantElektrikDenetim.salon")}</th>
                                                <th>{t("constantElektrikDenetim.islem")}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {filteredStands.map((stand) => (
                                                <tr key={stand.stand_id}>
                                                    <td style={tableStyles.cell}>{stand.stand_name}</td>
                                                    <td style={tableStyles.cell}>
                                                        <div style={{ overflow: "hidden" }}>{stand.name}</div>
                                                    </td>
                                                    <td style={tableStyles.cell}>{stand.hall}</td>
                                                    <td style={tableStyles.cell}>
                                                        <Button color="primary" onClick={() => openDenetimFormu(stand)}>
                                                            {t("constantElektrikDenetim.denetimFormu")}
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Modal isOpen={modalOpen} toggle={closeDenetimFormu} size="lg">
                <ModalHeader toggle={closeDenetimFormu}>{t("constantElektrikDenetim.denetimFormu")}</ModalHeader>
                <ModalBody>
                    {selectedStand && (
                        <DenetimFormu
                            formId={3} // You might want to dynamically set this
                            standId={selectedStand.stand_id}
                            selectedData={selectedStand}
                            activeFairId={activeFairId}
                            onClose={closeDenetimFormu}
                            documentTitle={documentTitle}
                        />
                    )}
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default ConstantElektrikDenetim;